var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"subheading"},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v(" mail ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }